import React from 'react';
import PropTypes from 'prop-types';
import {Image, Toaster} from '@learningblocks/storybook-components';
import {TubeSlots} from './TubeSlots';
import HeatBlockBench from '@learningblocks/exp-constants/lib/Images/heatBlock-bench.svg';
import {HeatBlockModal} from './HeatBlockModal';
import {Temperature} from './Temperature';
import {Tooltip} from './Tooltip';
import {useHeatblock} from './Heatblock.utils';

import style from './style.module.scss';

export let HeatblockContext = React.createContext();

export function HeatBlock(props) {
  const [timeLeft, setTimeLeft] = React.useState(30);

  React.useEffect(() => {
    if (props.isHeating) {
      const intervalId = setInterval(() => {
        setTimeLeft((t) => t - 1);
      }, 1000);
      return () => clearInterval(intervalId);
    }
  }, [props]);

  React.useEffect(() => {
    props.checkBalance();
  }, []);

  React.useEffect(() => {
    setTimeLeft(30);
    props.checkBalance();
  }, [JSON.stringify(props.testTube)]);

  React.useEffect(() => {
    adjustTemperature();
    props.checkBalance();
  }, [timeLeft]);

  const toastAlert = React.useContext(Toaster.Context);

  const adjustTemperature = () => {
    if (timeLeft === 0) {
      props.temperatureBalance();
    }
  };

  const onHeatBlockClick = () => {
    props.toggleModal(!props.isModalOpen);
  };

  const onTooltipEnter = () => {
    props.tubeTooltipDisplay();
  };

  const onTooltipLeave = () => {
    props.tubeTooltipRemove();
  };

  console.log(timeLeft, 'working');
  return (
    <HeatblockContext.Provider value={useHeatblock(props, toastAlert)}>
      <div
        className={style.heatBlock}
        onMouseEnter={onTooltipEnter}
        onMouseLeave={onTooltipLeave}
        >
        <TubeSlots
          slots={props.slots}
          onTubeDrop={props.onTubeDrop}
          tubeTooltip={props.tubeTooltip}
          isModalOpen={props.isModalOpen}
          toggleModal={props.toggleModal}
          filledSlots={props.filledSlots}
          removeTubeFromHeatblock={props.removeTubeFromHeatblock}
          isHeating={props.isHeating}
        />
        <Temperature
          temperature={props.temperature}
          currentTemp={props.currentTemp}
          balance={props.balance}
          isModalOpen={props.isModalOpen}
          toggleModal={props.toggleModal}
        />
        {props.tooltip ? <Tooltip filledSlots={props.filledSlots} /> : null}
        <Image
          src={HeatBlockBench}
          alt='Heat-Block-Bench'
          onClick={onHeatBlockClick}
          className={style.heatBlock_image}
        />
        <HeatBlockModal
          isModalOpen={props.isModalOpen}
          slots={props.slots}
          toggleModal={props.toggleModal}
          temperature={props.temperature}
          setTemperature={props.setTemperature}
          currentTemp={props.currentTemp}
          balance={props.balance}
          checkBalance={props.checkBalance}
          temperatureBalance={props.temperatureBalance}
          isHeating={props.isHeating}
          setTimeLeft={setTimeLeft}
        />
      </div>
    </HeatblockContext.Provider>
  );
}

HeatBlock.defaultProps = {
  /**
   * Modal window to open when clicking on the HeatBlock
   */
  isModalOpen: PropTypes.bool.isRequired,
  /**
   * Function to triger the modalwindow,to change the state 'isModalOpen'
   */
  toggleModal: PropTypes.func,
  /**
   * Tooltip to display on hover the heatblock
   */
  tooltip: PropTypes.bool,
  /**
   * Function to invoke tooltip
   */
  tooltipDisplay: PropTypes.func,
  /**
   * Function to remove tooltip
   */
  tooltipRemove: PropTypes.func,
  /**
   * Slots are the array which represent the filing of tube
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * It defines the number of slot in the heatblock
       */
      slotId: PropTypes.number.isRequired,
      /**
       * It defines the number of slot in the heatblock
       */
      tube: PropTypes.bool,
    })
  ).isRequired,
  /**
   * State to store the setTemperature value
   */
  temperature: PropTypes.number,
  /**
   * State to store the currentTemp value
   */
  currentTemp: PropTypes.number,
  /**
   * It denotes the current temperature and the setTemperature is equal or not
   */
  balance: PropTypes.bool,
  /**
   * Function to triggers to check the balance of the heat block
   */
  checkBalance: PropTypes.func,
  /**
   * Function to add the tube to the heatblock
   */
  onTubeDrop: PropTypes.func,
  /**
   * Boolean used to display the tube properties on hover
   */
  tubeTooltip: PropTypes.bool,
  /**
   * Function to invoke tube tooltip
   */
  tubeTooltipDisplay: PropTypes.func,
  /**
   * Function to remove tube tooltip
   */
  tubeTooltipRemove: PropTypes.func,
  /**
   * Filled slots is a interger which stores how many tubes are filled in heatblock
   */
  filledSlots: PropTypes.number,
  /**
   * Function used to remove the testtubes from Heatblock
   */
  removeTubeFromHeatblock: PropTypes.func,
  /**
   * Set temperature is a function to change the set Temperature
   */
  setTemperature: PropTypes.func,
  /**
   * It is a function used to change the current temperature to set
   * temperature after 30 seconds
   */
  temperatureBalance: PropTypes.func,
  /**
   * It is used to ideantify if the testtube is heating or not
   */
  isHeating: PropTypes.bool,
  /**
   * test tubes insterted to the heatblock
   */
  testTube: PropTypes.array,
};
